export default "__VITE_ASSET__D1bt$ZvO__"